import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private allowBack: boolean = false

  get preventBack(): boolean {
    return this.allowBack
  }

  set preventBack(value: boolean) {
    this.allowBack = value
  }
}
